import axios from 'axios'
import { encryptMD5,BrowserInfo } from '@/utils'
// import { Toast } from 'vant'
import store from '@/store'
import { IOS, Android } from '../JsBrage'
// 1.创建axios实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  responseType: 'json',
  timeout: 10000, // 超时,
  headers: { 'Content-Type': 'application/json' }
})

// 2.请求拦截
service.interceptors.request.use(
  config => {
    let key = process.env.VUE_APP_SERVER_KEY
    let signType = process.env.VUE_APP_SIGN_TYPE
    let timestamp = Math.round(new Date().getTime() / 1000).toString()
    let sign = encryptMD5(key + '&' + signType + '&' + timestamp)

    const data = {
      'channel': 3,
      'sign': sign,
      'timestamp': timestamp
    }

    if (config.method === 'post') {
      config.params = data
      config.data = JSON.stringify(config.data)
    } else {
      config.params = {
        ...config.params,
        ...data
      }
    }
    return config
  },
  error => {
    // 请求错误预处理
    return Promise.reject(error)
  }
)
// 3. 响应拦截
service.interceptors.response.use(
  response => {
    const res = response.data
    let msg = ''
    if (res.success) {
      if(res.errCode != '200') { // 校验错误
        return Promise.resolve(res.errCode)
      } else {
        return Promise.resolve(res.resultData)
      }
    } else {
      switch (res.errCode) {
        case '209': // 重新登录
          if(store.getters.platformChannel === '10') {
            var pl = BrowserInfo();
            if(pl.isIOS) {
              IOS.IosTransferLogin()
            } else {
              Android.AndroidTransferLogin()
            }
          } else {
            location.href = process.env.VUE_APP_ROOT_URL + 'index.html#/login?return_url=' + window.location.href
          }
          msg = '请登录'
          break
        case '500': // 系统异常
          msg = '系统异常，请稍后重试'
          break
        default:
          msg = res.errMessage
      }
    }
    return Promise.reject(msg)
  },
  error => {
    // Toast.clear()

    // TODO: 连接超时 需要判断
    return Promise.reject(error)
  }
)
/**
 * @description: get请求
 * @param {type}
 * @return: promis
 */
export function get (url, params = {}) {
  return new Promise((resolve, reject) => {
    service.get(url, {
      params: params
    })
      .then(response => {
        resolve(response)
      })
      .catch(err => {
        // Toast(err)
        reject(err)
      })
  })
}

/**
 * @description: post请求
 * @param {type}
 * @return: promise
 */

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(response => {
        resolve(response)
      }, err => {
        // Toast(err)
        reject(err)
      })
  })
}
